/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import classNames from 'classnames';
import React from 'react';
import UDText from '../text';

// Modal Header
export type ModalHeaderProps = {
  title: string;
  subtitle?: string;
  className?: string;
};

export const ModalHeader: React.FC<ModalHeaderProps> = ({ title, subtitle, className }) => {
  return (
    <div className={classNames('modal-header mb-2.5', className)}>
      <UDText isNew type="title-1" className="center">
        {title}
      </UDText>
      {subtitle && (
        <UDText isNew type="text-1" className="center text-Gray mt-2.5 whitespace-pre-wrap">
          {subtitle}
        </UDText>
      )}
    </div>
  );
};

// Modal Body
export type ModalBodyProps = {
  children: React.ReactNode;
  className?: string;
};

export const ModalBody: React.FC<ModalBodyProps> = ({ children, className }) => {
  return (
    <div className={classNames('modal-body', className)} css={modalBodyStyles}>
      {children}
    </div>
  );
};

const modalBodyStyles = () => css`
  flex: 1;
`;

// Modal Footer
export type ModalFooterProps = {
  children: React.ReactNode;
  className?: string;
  justify?: 'start' | 'center' | 'end' | 'between';
};

export const ModalFooter: React.FC<ModalFooterProps> = ({ children, className, justify = 'end' }) => {
  const justifyClass = {
    start: 'justify-start',
    center: 'justify-center',
    end: 'justify-end',
    between: 'justify-between',
  }[justify];

  return (
    <div className={classNames('modal-footer flex items-center gap-3', justifyClass, className)} css={modalFooterStyles}>
      {children}
    </div>
  );
};

const modalFooterStyles = css`
  margin-top: 40px;
  width: 100%;
`;
